import React, { useContext } from "react";
import { Box, Button, ButtonGroup } from "@mui/material";
import CustomGridToolbar from "components/GridToolbar";
import ImportModal from "./ImportAdoptionDecisionsSelect";
import BulkUpdateSelect from "./bulkUpdate/BulkUpdateSelect";
import MemoizedCreateAdoptionDecisions from "./CreateAdoptionDecisions";
import { UserContext } from "context";

function CustomToolBar({
  selectedHealthPlan,
  displayData,
  allPolicies,
  fetchData,
  hasDisplayData,
  selectedPolicies,
  showBulkUpdate,
}) {
  const userContext = useContext(UserContext);
  const healthPlanKey = selectedHealthPlan?.healthPlanKey;

  if (!healthPlanKey) return null;

  const isAvalon = selectedHealthPlan?.healthPlanName === "AHCS";
  //
  const exportComponent = (
    <ButtonGroup
      color="avalonBlueButton"
      variant="text"
      aria-label="Basic button group"
    >
      <ImportModal hpKey={healthPlanKey} onSubmit={fetchData} />
      {(userContext?.groups[0] === "POET-Avalon-Admin" ||
        userContext?.POETSkill?.includes("Manager") ||
        userContext?.POETSkill?.includes("Policy")) &&
      hasDisplayData ? (
        <MemoizedCreateAdoptionDecisions
          hpKey={healthPlanKey}
          gridData={displayData}
          refreshData={fetchData}
        />
      ) : (
        <Button disabled>Enter Adoption Decisions</Button>
      )}
      {isAvalon &&
        (showBulkUpdate ? (
          <BulkUpdateSelect
            selectedPolicies={selectedPolicies}
            selectedHealthPlan={selectedHealthPlan}
            allPolicies={allPolicies}
            refreshData={fetchData}
          />
        ) : (
          <Button disabled>Bulk Updates</Button>
        ))}
    </ButtonGroup>
  );

  return <CustomGridToolbar exportComponent={exportComponent} />;
}

export default CustomToolBar;
